import { ArrowLeft, Phone, Users } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../../config/axios-conf';
import styles from '../../../assets/scss/pages/EmployeeList.module.scss';
import { formatPhoneNumber } from '../../../utils/formatters';

const AVATAR_COLORS = ['#0098F6', '#22C55E', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#14B8A6', '#F97316'];
function getAvatarColor(name) {
    let hash = 0;
    for (let i = 0; i < (name || '').length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export default function TodayCustomers() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isNew = searchParams.get('type') === 'new';

    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await api.get('/statistics/today');
            if (isNew) {
                const list = data.listNewCustomer || [];
                setCustomers(list);
                setTotalCount(data.newCustomers || list.length);
            } else {
                const list = data.listTodayCustomer || [];
                setCustomers(list);
                setTotalCount(data.todayCustomers || list.length);
            }
        } catch {
            setCustomers([]);
        } finally { setLoading(false); }
    }, [isNew]);

    useEffect(() => { fetchData(); }, [fetchData]);

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <div className={styles.headerLeft} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <button style={{
                        width: 40, height: 40, border: '1.5px solid #ECEEF2', borderRadius: 10,
                        background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }} onClick={() => navigate(-1)}><ArrowLeft size={20} /></button>
                    <div>
                        <h1 className={styles.title}>
                            {isNew ? 'Khách hàng mới hôm nay' : 'Khách hàng hôm nay'}
                        </h1>
                        <p className={styles.subtitle}>{totalCount} khách</p>
                    </div>
                </div>
                <div className={styles.headerActions}>
                    <button
                        className={`${styles.btn}`}
                        style={{
                            background: !isNew ? '#0098F6' : '#fff',
                            color: !isNew ? '#fff' : '#6B7280',
                            border: '1.5px solid ' + (!isNew ? '#0098F6' : '#ECEEF2'),
                        }}
                        onClick={() => navigate('/admin/today-customers')}
                    >Tất cả</button>
                    <button
                        className={`${styles.btn}`}
                        style={{
                            background: isNew ? '#0098F6' : '#fff',
                            color: isNew ? '#fff' : '#6B7280',
                            border: '1.5px solid ' + (isNew ? '#0098F6' : '#ECEEF2'),
                        }}
                        onClick={() => navigate('/admin/today-customers?type=new')}
                    >Khách mới</button>
                </div>
            </div>

            {/* KPI */}
            <div className={styles.kpis} style={{ gridTemplateColumns: '1fr 1fr' }}>
                <div className={styles.kpi}>
                    <div className={styles.kpiContent}>
                        <span className={styles.kpiLabel}>{isNew ? 'Khách mới' : 'Tổng khách hôm nay'}</span>
                        <span className={styles.kpiValue}>{totalCount}</span>
                    </div>
                    <div className={`${styles.kpiIcon} ${styles.kpiIconBlue}`}><Users /></div>
                </div>
            </div>

            {/* Table */}
            <div className={styles.tableWrapper}>
                {loading ? (
                    <div className={styles.loading}><div className={styles.spinner} /> Đang tải...</div>
                ) : customers.length === 0 ? (
                    <div className={styles.empty}>{isNew ? 'Chưa có khách mới hôm nay' : 'Chưa có khách hôm nay'}</div>
                ) : (
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th style={{ width: 45, textAlign: 'center' }}>STT</th>
                                <th>Khách hàng</th>
                                <th>Số điện thoại</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customers.map((item, idx) => {
                                // listTodayCustomer: { customer: { id, name, phone } }
                                // listNewCustomer: { id, name, phone }
                                const cust = isNew ? item : (item.customer || item);
                                const custId = cust?.id || item?.customerId;
                                return (
                                    <tr key={custId || idx}
                                        className={styles.rowClickable}
                                        onClick={() => custId && navigate(`/admin/customers/${custId}`)}>
                                        <td style={{ textAlign: 'center', color: '#6B7280' }}>{idx + 1}</td>
                                        <td>
                                            <div className={styles.employeeCell}>
                                                <div className={styles.avatar} style={{ background: getAvatarColor(cust?.name) }}>
                                                    {(cust?.name || '?')[0].toUpperCase()}
                                                </div>
                                                <span className={styles.employeeName}>{cust?.name || 'Khách'}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className={styles.phoneCell}>
                                                <Phone size={14} />
                                                {cust?.phone ? formatPhoneNumber(cust.phone) : 'Chưa có'}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
